import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './auth/login/login.component';
import { OAuthCallbackComponent } from './auth/oauth-callback/oauth-callback.component';
import { RegisterOAuthComponent } from './auth/register-oauth/register-oauth.component';
import { RegisterComponent } from './auth/register/register.component';
import { RevertEmailChangeComponent } from './auth/revert-email-change/revert-email-change.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { ProfileComponent } from './profile/profile/profile.component';
import { MyListingsComponent } from './my-listings/my-listings.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { SwipeComponent } from './swipe/swipe.component';
import { MessagesComponent } from './messages/messages.component';
import { ConversationComponent } from './conversation/conversation.component';
import { ListingDetailsComponent } from './listing-details/listing-details.component';
import { EditListingComponent } from './edit-listing/edit-listing.component';
import { HelpCenterComponent } from './pages-helper/help-center/help-center.component';
import { ContactUsComponent } from './pages-helper/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './pages-legal/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages-legal/terms-of-service/terms-of-service.component';
import { AboutUsComponent } from './pages-more/about-us/about-us.component';
import { CareersComponent } from './pages-more/careers/careers.component';
import { FeesPaymentsComponent } from './pages-sell/fees-payments/fees-payments.component';
import { TipsComponent } from './pages-sell/tips/tips.component';
import { SellComponent } from './sell/sell.component';
import { SearchComponent } from './search/search.component';
import { RecentComponent } from './recent/recent.component';
import { FeaturedComponent } from './featured/featured.component';
import { TicketsComponent } from './tickets/tickets.component';
import { TicketDetailsComponent } from './tickets/ticket-details/ticket-details.component';
import { authGuard } from './guards/auth.guard';
import { nonAuthGuard } from './guards/non-auth.guard';
import { nonAdminGuard } from './guards/non-admin.guard';
import { adminGuard } from './guards/admin.guard';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { AdminPendingListingsComponent } from './admin/admin-pending-listings/admin-pending-listings.component';
import { AdminActionsComponent } from './admin/admin-actions/admin-actions.component';
import { AdminMarketingComponent } from './admin/admin-marketing/admin-marketing.component';
import { AdminContactSupportComponent } from './admin/admin-contact-support/admin-contact-support.component';
import { AdminEmbeddingsComponent } from './admin/admin-embeddings/admin-embeddings.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [nonAdminGuard] },
  { path: 'home', component: HomeComponent, canActivate: [nonAdminGuard] },
  { path: 'login', component: LoginComponent, canActivate: [nonAuthGuard] },
  { path: 'oauth-callback', component: OAuthCallbackComponent },
  { path: 'oauth-success', component: OAuthCallbackComponent },
  { path: 'register-oauth', component: RegisterOAuthComponent, canActivate: [nonAuthGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [nonAuthGuard] },
  { path: 'revert-email-change', component: RevertEmailChangeComponent },
  { path: 'verify-email', component: EmailVerificationComponent, canActivate: [nonAuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [nonAuthGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [nonAuthGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'my-listings', component: MyListingsComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'wishlist', component: WishlistComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'tickets', component: TicketsComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'tickets/:id', component: TicketDetailsComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'swipe', component: SwipeComponent, canActivate: [authGuard] },
  { path: 'messages', component: MessagesComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'messages/:id', component: ConversationComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'listing-details/:subcategory/:id', component: ListingDetailsComponent },
  { path: 'edit-listing/:id', component: EditListingComponent, canActivate: [authGuard, nonAdminGuard] },
  { path: 'search/:category/:subcategory/:keyword', component: SearchComponent, canActivate: [nonAdminGuard] },
  { path: 'search/:category/:keyword', component: SearchComponent, canActivate: [nonAdminGuard] },
  { path: 'search/:category', component: SearchComponent, canActivate: [nonAdminGuard] },
  { path: 'search', component: SearchComponent, canActivate: [nonAdminGuard] },
  { path: 'search/reverse-image-results', component: SearchComponent, canActivate: [nonAdminGuard] },
  { path: 'recent', component: RecentComponent, canActivate: [nonAdminGuard] },
  { path: 'featured', component: FeaturedComponent, canActivate: [nonAdminGuard] },
  { path: 'sell', component: SellComponent, canActivate: [authGuard, nonAdminGuard] },
  {
    path: 'admin',
    canActivate: [adminGuard],
    children: [
      { path: '', component: AdminDashboardComponent },
      { path: 'dashboard', component: AdminDashboardComponent },
      { path: 'pending-listings', component: AdminPendingListingsComponent },
      { path: 'actions', component: AdminActionsComponent },
      { path: 'marketing', component: AdminMarketingComponent },
      { path: 'support', component: AdminContactSupportComponent },
      { path: 'embeddings', component: AdminEmbeddingsComponent }
    ]
  },
  { path: 'help-center', component: HelpCenterComponent, canActivate: [nonAdminGuard] },
  { path: 'contact-us', component: ContactUsComponent, canActivate: [nonAdminGuard] },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, canActivate: [nonAdminGuard] },
  { path: 'terms-of-service', component: TermsOfServiceComponent, canActivate: [nonAdminGuard] },
  { path: 'about-us', component: AboutUsComponent, canActivate: [nonAdminGuard] },
  { path: 'careers', component: CareersComponent, canActivate: [nonAdminGuard] },
  { path: 'fees-payments', component: FeesPaymentsComponent, canActivate: [nonAdminGuard] },
  { path: 'tips', component: TipsComponent, canActivate: [nonAdminGuard] },
  { path: 'coming-soon', component: ComingSoonComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: '**', component: NotFoundComponent, canActivate: [nonAdminGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
